import { ICurrency } from "types/ICurrency";
import api from "./api";

export default class CurrencyService {
  async getCurrency(): Promise<ICurrency[]> {
    const response = await api.get(`/v1/currency`);
    return response.data;
  }
}
